export interface PageDetails {
	pageNo: number;
	pageSize: number;
}

export const ERROR_MESSAGES = {
	FETCH_REQUESTS_FAILED: 'Failed to fetch requests',
	CREATE_REQUEST_FAILED: 'Failed to create request',
	CSV_EMPTY: 'CSV file is empty',
	CSV_INVALID_HEADER: 'Invalid header. Expected "TxnId"',
	CSV_NO_ROWS: 'CSV file has no data rows',
	CSV_TOO_MANY_ROWS: (limit: number) => `CSV contains more than ${limit} rows`,
	CSV_FILE_REQUIRED: 'CSV file is required'
};

export interface StartSuspiciousTransactionsRequest {
	queryLabel: string;
	startDate: string;
	rows: string[];
	userMerchant?: string;
}

export interface ListSuspiciousTransactionsRequest {
	queryLabel: string;
	pageNo: number;
	pageSize: number;
	userMerchant?: string;
}

export interface ListSuspiciousTransactionsResponse {
	success: boolean;
	message?: string;
	data: {
		requests: any[];
		totalCount: number;
	};
}

export interface StartSuspiciousTransactionsResponse {
	success: boolean;
	message?: string;
	requestId: string;
}
